import { FC, Fragment } from "react";
import { makeStyles, createStyles, FormControl, Grid } from "@material-ui/core";
import { FormControlLabel } from "../core/FormControlLabel";
import { ChangeNames, FormModel } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { Checkbox } from "../core/Checkbox";
import { Colors } from "../../styles";
import { useStyles } from "../../useStyles";
import { useFormikContext } from "formik";
import { useNavigate } from "react-router-dom";

const useFormControlStyle = makeStyles(() =>
    createStyles({
        container: {
            display: "flex",
            flexDirection: "row",
        },
        containerError: {
            backgroundColor: Colors.radiantRedFill,
            borderColor: Colors.radiantRed,
            borderStyle: "solid",
            borderWidth: "1px",
            borderRadius: 8,
        },
        formControlLabelStyle: {
            marginRight: 110,
        },
        checkboxStyle: {
            marginRight: 8,
        },
    }),
);

export const ProductClassesForm: FC = () => {
    const classes = useStyles();
    const navigate = useNavigate();

    const { values: buildingAddressValues } =
        useFormikContext<FormModel<ChangeNames.BUILDING_ADDRESS>>();
    if (
        !(
            buildingAddressValues?.buildingAddress?.city.value &&
            buildingAddressValues?.buildingAddress?.zipCode.value
        )
    ) {
        navigate("/address");
    }

    const { values, setValues } = useFormModel<ChangeNames.PRODUCT_CLASSES>();
    const formControlClasses = useFormControlStyle();

    return (
        <Fragment>
            <FormControl
                component="fieldset"
                className={classes.container}
                style={{ display: "flex" }}
            >
                <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 40 }}>
                    Anschlussart/-en wählen
                </h4>
                <Grid container spacing={7} className={formControlClasses.container}>
                    <Grid item>
                        {values.productClasses.value.power !== undefined && (
                            <FormControlLabel
                                isCheckBox={true}
                                className={formControlClasses.formControlLabelStyle}
                                control={
                                    <Checkbox
                                        className={formControlClasses.checkboxStyle}
                                        value="power"
                                        checked={values.productClasses.value.power}
                                        disabled={values.productClasses.value.power === undefined}
                                        onChange={(_, checked) =>
                                            setValues((values) => {
                                                values.productClasses.value.power = checked;
                                            })
                                        }
                                    />
                                }
                                label="Strom"
                                error={values.productClasses.error ? true : false}
                            />
                        )}
                        {values.productClasses.value.gas !== undefined && (
                            <FormControlLabel
                                isCheckBox={true}
                                control={
                                    <Checkbox
                                        className={formControlClasses.checkboxStyle}
                                        value="gas"
                                        checked={values.productClasses.value.gas}
                                        disabled={values.productClasses.value.gas === undefined}
                                        onChange={(_, checked) =>
                                            setValues((values) => {
                                                values.productClasses.value.gas = checked;
                                            })
                                        }
                                    />
                                }
                                label="Gas"
                                error={values.productClasses.error ? true : false}
                            />
                        )}
                    </Grid>
                </Grid>
            </FormControl>
        </Fragment>
    );
};
